import { api } from '../axios'
import type { ApiResponse, BlockOffice } from '../../../types'

export const blockOfficesApi = {
  getAll: () =>
    api.get<ApiResponse<BlockOffice[]>>('/block-offices'),

  getAllIncludingInactive: () =>
    api.get<ApiResponse<BlockOffice[]>>('/block-offices/all'),

  getActive: () =>
    api.get<ApiResponse<BlockOffice[]>>('/block-offices/active'),

  getById: (id: number) =>
    api.get<ApiResponse<BlockOffice>>(`/block-offices/${id}`),

  create: (data: BlockOffice) =>
    api.post<ApiResponse<BlockOffice>>('/block-offices', data),

  update: (id: number, data: Partial<BlockOffice>) =>
    api.put<ApiResponse<BlockOffice>>(`/block-offices/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/block-offices/${id}`),
  
  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/block-offices/${id}/permanent`),
}

